import mountAccordion from '../../../components/mountAccordion';

/**
 * handleTradeInOverlayOpen
 */
export const handleTradeInOverlayOpen = () => {
    const accordionWrapper = document.getElementById('tradein-accordion-container');
    mountAccordion(accordionWrapper);
};
